import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHashtag24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconHashtag24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.742 4.106a.75.75 0 1 0-1.485-.212l-.593 4.156h-4.2l.564-3.944a.75.75 0 0 0-1.485-.212L8.95 8.05H5.143a.75.75 0 1 0 0 1.5h3.592l-.7 4.9H4a.75.75 0 0 0 0 1.5h3.821l-.563 3.944a.75.75 0 0 0 1.484.212l.594-4.156h4.2l-.564 3.944a.75.75 0 1 0 1.485.212l.593-4.156h3.807a.75.75 0 0 0 0-1.5h-3.592l.7-4.9H20a.75.75 0 0 0 0-1.5h-3.821zM14.45 9.55h-4.198l-.7 4.9h4.198z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHashtag24);
